<div (click)="dismiss()"  class="snack-content-container" aria-labelledby="toast-message" role="group">
  <div class="snack-icon">
    <button (click)="dismiss()" mat-icon-button [attr.aria-label]="icon_label">
      <mat-icon>{{toast_icon}}</mat-icon>
    </button>
  </div>
  <div class="snack-message" [attr.aria-label]="data.message" role="alert">
    @if (data.title) {
      <strong>{{ data.title }}</strong><br>
    }
    <p class="information" id="toast-message">
      {{ data.message }}
    </p>
  </div>
</div>
